import config from '../config';
import createClient from '../apollo/utils/createClient';

export default createClient(config.api.baseUrl, {
  loginUrl: config.login.baseUrl
});
